import { URLS } from 'config';

export interface StepBasis {
  label: string;
  urls: string[];
}

export const STEPS: StepBasis[] = [
  {
    label: 'Account',
    urls: [URLS.setupAccount, URLS.setupBusinessConfig],
  },
  {
    label: 'Info',
    urls: [URLS.setupInfo],
  },
  {
    label: 'Subscription',
    urls: [URLS.setupSubscription],
  },
];

export const STEP_BASE_CLASSNAME =
  'text-center first:text-left last:text-right text-14-22-em';

export const STEP_CLASSNAMES = {
  active: [STEP_BASE_CLASSNAME, 'text-purple-500'].join(' '),
  default: [STEP_BASE_CLASSNAME, 'text-neutral-500'].join(' '),
};
